(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else if(typeof exports === 'object')
		exports["@wix/santa-multilingual"] = factory(require("lodash"));
	else
		root["@wix/santa-multilingual"] = factory(root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 